import path from "path";

import { cp, mkdir, ls } from "shelljs";
import { readFile } from "fs-extra";

import { isDirectoryExists, isFileExists, writeFileAsync } from "../Commons/FsUtils";
import { ILogger } from "../Commons/Logging/ILogger";

export class FSTask {
    private static findMaxBasePath(firstPath: string, secondPath: string): string {
        let currentPath = firstPath;
        while (currentPath !== path.dirname(currentPath)) {
            if (secondPath.includes(currentPath)) {
                return currentPath;
            }
            currentPath = path.dirname(currentPath);
        }
        return "";
    }

    private static logCopy(logger: ILogger, sourceDirectory: string, targetDirectory: string): void {
        const basePath = this.findMaxBasePath(sourceDirectory, targetDirectory);
        logger.log(`Copy ${sourceDirectory.replace(basePath, "")} -> ${targetDirectory.replace(basePath, "")}`);
    }

    public static async copyRecursively(
        logger: ILogger,
        sourceDirectory: string,
        targetDirectory: string
    ): Promise<void> {
        if (await isDirectoryExists(sourceDirectory)) {
            this.logCopy(logger, sourceDirectory, targetDirectory);
            mkdir("-p", targetDirectory);
            cp("-R", sourceDirectory + "/*", targetDirectory);
        }
    }

    public static async copyByMasks(
        logger: ILogger,
        sourceDirectory: string,
        masks: string[],
        targetDirectory: string
    ): Promise<void> {
        if (await isDirectoryExists(sourceDirectory)) {
            mkdir("-p", targetDirectory);
            for (const mask of masks) {
                this.logCopy(logger, sourceDirectory, targetDirectory);
                cp(sourceDirectory + "/" + mask, targetDirectory);
            }
        }
    }

    public static async copyFile(logger: ILogger, sourceFileName: string, targetFileName: string): Promise<void> {
        if (await isFileExists(sourceFileName)) {
            this.logCopy(logger, sourceFileName, targetFileName);
            mkdir("-p", path.join(path.dirname(targetFileName)));
            cp(sourceFileName, targetFileName);
        }
    }

    public static async modifyFilesContent(
        logger: ILogger,
        sourceDirectory: string,
        targetDirectory: string,
        mask: string,
        modifier: (content: string) => string
    ): Promise<void> {
        if (await isDirectoryExists(sourceDirectory)) {
            logger.log(`Modify files from ${sourceDirectory}`);
            const sourceFiles = ls(`${sourceDirectory}/${mask}`);
            await Promise.all(
                sourceFiles.map(async f => {
                    const targetFile = path.join(targetDirectory, path.basename(f));
                    if (await isFileExists(targetFile)) {
                        const content = await readFile(targetFile, { encoding: "utf8" });
                        await writeFileAsync(targetFile, modifier(content), "utf8");
                    }
                })
            );
        }
    }
}
